import MapboxProvider from '@resources/js/maps/MapboxProvider'

export default class MapView {
    #providerOptions
    #provider

    constructor(mapOptions = {}) {

        this.container = document.querySelector('#mapbox');

        this.#providerOptions = {
            center: [this.container.dataset.lng, this.container.dataset.lat],
            control: 'bottom-right',
            ...mapOptions
        }

        this.#provider = new MapboxProvider(this.#providerOptions)
        this.#provider.init()
    }

    addHotelMarker() {
        const marker = this.#provider.createMarker({coords: [this.container.dataset.lng, this.container.dataset.lat]})
        this.#provider.addMarkerToMap(marker)
    }

    addMarkers(data, templateGenerator) {
        // data має містити id, lng, lat
        data.forEach(item => {
            if (item.lng && item.lat) {
                const marker = this.createMarker(item,
                    templateGenerator ? templateGenerator(item) : null)

                this.#provider.addMarkerToMap(marker)
            }
        })
    }

    createMarker(item, template) {
        return this.#provider.createMarker({
            id: item.id,
            coords: [item.lng, item.lat],
            markerTemplate: template,
        })
    }


    fitByCoords(coords) {
        if(!coords?.length) return

        const bounds = this.#provider.generateBounds(coords);
        this.#provider.fitBounds(bounds);
    }
}
